import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

// PrimeReact-based confirmation dialog (replaces Bootstrap modal)
export default function ConfirmModal({ show, title = 'Confirm', message, confirmText = 'Yes', cancelText = 'Cancel', onConfirm, onCancel, style }) {
  return (
    <Dialog
      header={title}
      visible={!!show}
      onHide={onCancel}
      style={{ width: '28rem', ...(style || {}) }}
      modal
      closable
      dismissableMask
      appendTo={document.body}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <Button label={cancelText} icon="pi pi-times" outlined onClick={onCancel} />
          <Button label={confirmText} icon="pi pi-check" onClick={onConfirm} autoFocus />
        </div>
      }
    >
      <div style={{ lineHeight: 1.5 }}>{message}</div>
    </Dialog>
  );
}